import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { LoaderArea } from '@ubeya/shared-web/components';
import { getDateLabel } from '../../helpDeskUtils';
import MessageBubble from './MessageBubble';
import DateSeparator from './DateSeparator';
import UnreadDivider from './UnreadDivider';

const getMessageSenderKey = (msg) => {
  const senderId = msg.sender?.id || msg.senderId || msg.senderAdminId || msg.adminId || msg.employeeId;

  if (senderId) {
    return `${msg.senderType || 'unknown'}-${senderId}`;
  }

  return `${msg.senderType || 'unknown'}-${msg.senderName || msg.sender?.name || msg.id}`;
};

const getMessageUserKey = (msg) =>
  msg.isAutomated === true ? `automated-${getMessageSenderKey(msg)}` : getMessageSenderKey(msg);

const getMessageLabelGroupKey = (msg) => `${getMessageUserKey(msg)}-${msg.messageType || 'message'}`;

const MessagesList = ({ groupedItems, accountId, ticketId, isLoading, onOpenPdf, compact = false, messagesEndRef }) => {
  const { t } = useContext(ConfigContext);
  let previousMessageUserKey = null;
  let previousMessageLabelGroupKey = null;

  return (
    <>
      {isLoading && <LoaderArea />}
      {groupedItems.map((item, index) => {
        if (item.type === 'date') {
          previousMessageUserKey = null;
          previousMessageLabelGroupKey = null;
          return <DateSeparator key={item.key} label={getDateLabel(item.date, t)} compact={compact} />;
        }
        if (item.type === 'unread') {
          previousMessageUserKey = null;
          previousMessageLabelGroupKey = null;
          return <UnreadDivider key={item.key} compact={compact} />;
        }
        const userKey = getMessageUserKey(item.data);
        const labelGroupKey = getMessageLabelGroupKey(item.data);
        const isFirstInUserGroup = userKey !== previousMessageUserKey;
        const showSenderLabel = labelGroupKey !== previousMessageLabelGroupKey;
        const nextItem = groupedItems[index + 1];
        const isGroupedWithNext = nextItem?.type === 'message' && getMessageUserKey(nextItem.data) === userKey;
        previousMessageUserKey = userKey;
        previousMessageLabelGroupKey = labelGroupKey;

        return (
          <MessageBubble
            key={item.key}
            msg={item.data}
            accountId={accountId}
            ticketId={ticketId}
            t={t}
            onOpenPdf={onOpenPdf}
            compact={compact}
            showSenderLabel={showSenderLabel}
            showArrow={isFirstInUserGroup}
            isFirstInUserGroup={isFirstInUserGroup}
            isGroupedWithNext={isGroupedWithNext}
          />
        );
      })}
      {messagesEndRef && <div ref={messagesEndRef} />}
    </>
  );
};

export default MessagesList;
